export default {
  showHidden: 'Versteckte Signale anzeigen',
  deselectAll: 'Alle abwählen',
  newSignal: 'Neues virtuelles Signal',
};
